var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImagesmode = function SvgImagesmode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 976q-50 0-85-35t-35-85V296q0-50 35-85t85-35h560q50 0 85 35t35 85v560q0 50-35 85t-85 35zm0-60h560q25.5 0 42.75-17.25T820 856V296q0-25.5-17.25-42.75T760 236H200q-25.5 0-42.75 17.25T140 296v560q0 25.5 17.25 42.75T200 916m64-110 136-136 73 72 87-110 139 174zm55.911-320Q291 486 270.5 465.411t-20.5-49.5 20.589-49.411 49.5-20.5 49.411 20.589 20.5 49.5-20.589 49.411-49.5 20.5"
  })));
};
export default SvgImagesmode;